import React from "react";
import { FaAddressBook, FaPlus, FaRegArrowAltCircleLeft, FaSync, FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SettingGeneralProvider } from "../../../context/settingGeneralContext";
import HeaderReusable from "../../Global/HeaderContent";

export default function HeaderOdontogramRestorationMaterial({
    isTabletOrMobile,
    title = "List Odontogram Restoration Material",
    query,
    setQuery,
    limit,
    setLimit,
    viewModalAdd,
    searchData,
    buttonRefresh,
    showCustomButtonBack,
    showCustomButtonRelationPatient
}) {
    return (
        <SettingGeneralProvider>
            <HeaderOdontogramRestorationMaterialContent
                isTabletOrMobile={isTabletOrMobile}
                title={title}
                query={query}
                setQuery={setQuery}
                limit={limit}
                setLimit={setLimit}
                viewModalAdd={viewModalAdd}
                buttonRefresh={buttonRefresh}
                searchData={searchData}
                showCustomButtonBack={showCustomButtonBack}
            />
        </SettingGeneralProvider>
    )
}

function HeaderOdontogramRestorationMaterialContent({
    title,
    query,
    setQuery,
    limit,
    setLimit,
    viewModalAdd,
    searchData,
    buttonRefresh,
    showCustomButtonBack
}) {
    return (
        <>
            <HeaderReusable
                title={title}
                icon={FaAddressBook}
                isTabletOrMobile={false}
                query={query}
                setQuery={setQuery}
                limit={limit}
                setLimit={setLimit}
                onAdd={viewModalAdd}
                searchData={searchData}
                showAddButton={true}
                onRefresh={buttonRefresh}
                showRefreshButton={true}
                showCustomButtonBack={showCustomButtonBack}
            />
        </>
    )
}
